import Resource from '@/api/resources/Resource'

class SectionServices extends Resource {
    async getSections(laboratoryId) {
        const response = await this.axios.get(`/laboratories/${laboratoryId}/sections`)
        return response.data
    }
}

export default new SectionServices()
